import { connect } from 'react-redux';
import { Actions } from '../actions';
import UnauthenticatedNavigationMobile from '../components/UnauthenticatedNavigationMobile';

export default connect(
  null,
  {
    onOpenMobileDrawer: Actions.openMobileDrawer,
  },
)(UnauthenticatedNavigationMobile);
